import PaymentBlock from './PaymentBlock';
import { PaymentBlockProps, PaymentBlockValueProps } from './types';

export type { PaymentBlockProps, PaymentBlockValueProps };
export default PaymentBlock;
